// extracted by mini-css-extract-plugin
module.exports = {"pit_box":"pit_box-3TM6v2Fa"};